import React, { createContext, useContext, useEffect, useState } from 'react';
import useScroll from '../hooks/useScroll';

const UiContext = createContext();

export function UiProvider({ children }) {
    const { y: scrollY } = useScroll();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [activeDemoTab, setActiveDemoTab] = useState('cct');

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const closeMenu = () => setIsMenuOpen(false);

    // Handle body scroll locking when menu is open
    useEffect(() => {
        const body = document.body;
        if (isMenuOpen) {
            body.classList.add('menu-open');
            body.style.overflow = 'hidden';
        } else {
            body.classList.remove('menu-open');
            body.style.overflow = '';
        }

        return () => {
            body.classList.remove('menu-open');
            body.style.overflow = '';
        };
    }, [isMenuOpen]);

    return (
        <UiContext.Provider
            value={{
                scrollY,
                isMenuOpen,
                toggleMenu,
                closeMenu,
                isLoading,
                activeDemoTab,
                setActiveDemoTab
            }}
        >
            {children}
        </UiContext.Provider>
    );
}

export function useUi() {
    return useContext(UiContext);
}
